function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29.396 18.287a16.19 16.19 0 0 0-16.224 16.227v51.54a16.19 16.19 0 0 0 16.224 16.226H50.91l5.652 9.793 8.333 14.43 8.33-14.43 5.653-9.793h21.515a16.19 16.19 0 0 0 16.224-16.226v-51.54a16.19 16.19 0 0 0-16.224-16.227z",
    style: {
      fill: "#ff9348"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.831 39.9-1.23 23.784q-.16 1.866-1.43 3.097-1.39 1.23-3.256 1.23t-3.296-1.23q-1.31-1.231-1.43-3.097l-1.23-23.785q-.08-2.025 1.31-3.454 1.31-1.43 3.335-1.47h2.581q2.025 0 3.336 1.47 1.469 1.43 1.31 3.454M69.68 84.251q-1.867 2.025-4.725 2.025-2.82 0-4.845-1.985t-2.025-4.765 2.025-4.805q2.025-2.065 4.845-2.065t4.725 2.026q2.025 1.945 2.025 4.804 0 2.82-2.025 4.765",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIcon;